// extracted by mini-css-extract-plugin
export var description = "unified-search-result-list-item-module--description--bf682";
export var searchResult = "unified-search-result-list-item-module--searchResult--93cc2";
export var title = "unified-search-result-list-item-module--title--b0466";